import { Project } from '../domain/project/Project';
import { WeatherForecast } from '../domain/weather/WeatherForecast';
import { weatherRepository } from '../repositories/weather';
import { WeatherRepository } from '../repositories/weather/WeatherRepository';

export class WeatherService {
  constructor(private weatherRepository: WeatherRepository) {}

  async retrieveForecast({ project }: { project: Project }): Promise<WeatherForecast[]> {
    return this.weatherRepository.retrieveForecast({ projectId: project.id });
  }
}

export const weatherService = new WeatherService(weatherRepository);
